import { Helmet } from 'react-helmet-async'

export const Terms = () => {
  return (
    <div className='container my-10 mx-auto flex flex-col items-start bg-[#5E81AC] p-6 text-white rounded-md'>
      <Helmet>
        <title className='text-xl font-semibold font-semibold'>
          {' '}
          قوانین و مقررات بوک استوری
        </title>
        <meta
          name='description'
          content='بوک استوری - هر کتاب یک داستان، هر داستان یک زندگی دوباره'
        />
      </Helmet>
      <div className='w-full flex flex-col  items-center lg:items-start my-6'>
        <h1 className='text-xl font-semibold font-semibold my-2 border-b-2 py-2 w-3/4'>
          قوانین و مقررات بوک استوری
        </h1>
        <div className='mt-4'>
          <h2 className='text-lg font-medium font-medium my-2'>
            کتاب های موجود در سایت دارای چهار درجه بندی کیفیت می‌باشند :
          </h2>
          <p className='text-lg font-medium font-medium text-right my-4'>
            <span>نو: </span>
            <span>این کتاب ها نو هستند.</span>
          </p>
          <p className='text-lg font-medium font-medium text-right my-4'>
            <span>در حد نو : </span>
            <span>این کتاب‌ها دارای کمترین آثار استفاده شدگی هستند.</span>
          </p>
          <p className='text-lg font-medium font-medium text-right my-4'>
            <span>خوب : </span>
            <span>
              این کتاب ها اگر چه خوانده شده‌اند و روی آنها آثار استفاده‌شدگی
              قابل مشاهده است، اما دارای وضعیت خوبی می باشند. در صفحات معدودی از
              این کتاب ها ممکن است تعداد کمی خط­ کشی قابل مشاهده باشد.
            </span>
          </p>
          <p className='text-lg font-medium font-medium text-right my-4'>
            <span>قابل قبول : </span>
            <span>
              {' '}
              آثار استفاده‌ شدگی در این کتاب‌ها بیشتر قابل مشاهده است. این
              کتاب‌ها اما قابل استفاده و بدون پارگی، رطوبت گرفتگی یا لک هستند.
              در این کتاب‌ها آثار خط کشی و دست نوشته هایی نیز به طور معدود
              مي‌تواند قابل مشاهده باشد.
            </span>
          </p>
        </div>
        <p className='text-lg font-medium font-medium text-right my-3'>
          سفارشات، پس از تایید پرداخت طي یک تا سه روز کاری آماده و تحویل پست
          می‌شوند. پس از پرداخت، پیامکی حاوی اطلاعات سفارش به صورت خودکار برای
          مشتری ارسال می‌شود. در صورت عدم دریافت این پیامک با بخش پشتیبانی از
          طریق ایمیل یا تلفن ارتباط برقرار كنيد. علاوه بر آن شما می توانید
          جزییات سفارش را در پنل کاربری خود مشاهده کنید.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          {' '}
          کتاب‌های سفارش داده شده اصولا در انبار بوک استوری موجود هستند و برای
          شما ارسال می‌گردند. در موارد بسیار معدودی ممکن است کتاب مورد نظر شما
          در انبار موجود نباشد. که در این صورت برای هماهنگی جهت بازگرداندن هزینه
          پرداخت شده، با شما تماس گرفته خواهد شد.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          کتاب های دست دوم را می توانید تا هفت روز پس از دریافت مرجوع کنید. مبلغ
          پرداختی کتاب به حساب شما بازگردانده می شود. (پيش از بازگرداندن كتاب ها
          حتما با واحد پشتيباني ارتباط برقرارر كنيد.)
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          پشتیبانی از لوح فشرده همراه کتاب‌ها و همچنین بسته‌های نرم افزاری
          برعهده تولیدکننده یا ناشر است. در صورت بروز مشکل بوک استوری مسئولیتي
          در این خصوص ندارد، اما تلاش خواهد کرد در حد امکان مشکل مشتری مرتفع
          گردد.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          اطلاعات توسط مشتریان در سايت بوک استوری صرفاً برای ارائه خدمات مورد
          استفاده قرار ميگيرد و تحت هیچ شرایطی در اختیار شخص ثالث قرار نخواهد
          گرفت.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          بوک استوری اخبار و اطلاعات خود و شرایط فروش ویژه را به صورت دوره‌ای
          برای مشتریان ارسال خواهد کرد.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          هنگام ثبت سفارش، طبق قوانین شرکت پست جمهوری اسلامی ایران، درج کد پستی
          صحیح اجباری است. در صورت عدم درج کد پستی یا ناقص بودن آن، مسئولیت عدم
          دریافت بسته یا برگشت آن برعهده مشتری است و ارسال مجدد مشمول پرداخت
          مجدد هزینه پستی است.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          طبق قانون اداره پست مامور تحويل سفارش پستي باید برای تحویل بسته‌های
          پیشتاز حداقل دو بار به نشاني مراجعه کند و در صورت عدم حضور گواهی حضور
          نداشتن نصب کند، تا گیرنده طي ده روز با مراجعه به باجه معطله، بسته را
          دریافت کند. اگر فکر می‌کنید امکان عدم حضور در آدرس‌تان وجود دارد، بسته
          را با پست پیشتاز خریداری کنید تا مسئولیت بیشتری برای تحویل برعهده
          اداره پست باشد.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          هنگام ارسال بسته پستی، نام، نشاني، کد پستی و تلفن‌های ارائه شده توسط
          مشتری روی پاکت درج می‌شود تا امکان تماس مأمور پست با گیرنده در موارد
          اضطراری فراهم باشد.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          بن هاي تخفیف و جوایز ارائه شده به مشتریان فقط در یک ارسال سفارش قابل
          استفاده هستند و در صورت برگشت سفارش به هر دلیل، این مبلغ به مشتری پس
          داده نميشود.
        </p>
        <p className='text-lg font-medium font-medium text-right my-3'>
          ما در سایت بوک استوری در حال تلاش مستمر برای بهبود خدمات خود به شما
          مشتریان عزیز هستیم. برای تحقق این امر نظرات خود را از طریق آدرس ایمیل
          Info@bookstory.com با ما در میان بگذارید.
        </p>
      </div>
    </div>
  )
}
